import type { StackedChartSection } from 'components/StackedChart/types'
import type { Moment } from 'moment-timezone'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { applyAWCChartOverrides, applyHeatmapChartOverrides } from './_utils/applySoilChartOverrides'
import { SoilChartItem } from './SoilChartItem'
import { SoilZoneHeader } from './SoilZoneHeader'
import type { TIrrigationInterval } from './types'

export const SoilZoneCharts = ({
  title,
  awcChart,
  awcHeatmap,
  intervalsForChart,
  soilStationFavoriteDepths,
  soilDateFrom,
  soilDateTo,
  timezone,
  selectedProperty,
}: {
  title: string
  awcChart: StackedChartSection
  awcHeatmap: StackedChartSection
  intervalsForChart: TIrrigationInterval[]
  soilStationFavoriteDepths: Array<string | number>
  soilDateFrom: Moment
  soilDateTo: Moment
  timezone: string
  selectedProperty: TProperty
}) => {
  return (
    <div key={title} css={{ marginBottom: 40 }}>
      {awcChart.items.map((item, i) => {
        const chartConfig = applyAWCChartOverrides({
          chartConfig: item.chartConfig,
          soilDateFrom,
          soilDateTo,
        })

        return (
          <div key={item.chartConfig.semiosHighchartsAdditions.id}>
            {i === 0 && (
              <SoilZoneHeader
                title={title}
                soilStationFavoriteDepths={soilStationFavoriteDepths}
                intervalsForChart={intervalsForChart}
                soilDateFrom={soilDateFrom}
                soilDateTo={soilDateTo}
                selectedProperty={selectedProperty}
              />
            )}
            {/* AWC Line Chart */}
            <SoilChartItem
              chart={chartConfig}
              chartVisible={true}
              childrenLower={item.childrenLower}
              childrenUpper={item.childrenUpper}
              timezone={timezone}
            />
          </div>
        )
      })}
      {/* HEATMAP */}
      {awcHeatmap.items.map((item) => {
        const chartConfig = applyHeatmapChartOverrides({
          chartConfig: item.chartConfig,
        })

        return (
          <SoilChartItem
            key={chartConfig.semiosHighchartsAdditions.id}
            chart={chartConfig}
            chartVisible={true}
            childrenLower={item.childrenLower}
            childrenUpper={item.childrenUpper}
            timezone={timezone}
          />
        )
      })}
    </div>
  )
}
